export default __webpack_public_path__ + "static/media/T19.2db5df04.png";